module.exports = __webpack_public_path__ + "img/baseModule.709048ff.svg";